module.exports = __webpack_public_path__ + "img/card-spread.b27366f6.png";